import React from 'react';
import './ProductTutorials.scss';
import Pages from '../pages/Pages';

interface ProductTutorialsProps {
  tutorials: {
    edges: any;
  };
  product: string;
}

// ProductTutorials displays a list of tutorial links
export default function ProductTutorials({ tutorials, product }: ProductTutorialsProps): React.ReactElement {
  return (
    <div className="product-tutorials">
      <Pages>{tutorials}</Pages>
    </div>
  );
}
